import React, { useEffect, useState } from "react";
import { BrowserRouter, Redirect, Route as RouterRoute, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Reports from "../pages/Reports";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import GroupsWA from "../pages/GroupsWA";
import GroupCampaigns from "../pages/GroupCampaigns";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import ForgotPassword from "../pages/PasswordRecovery/ForgotPassword";
import ResetPassword from "../pages/PasswordRecovery/ResetPassword";
import PrivacyPolicy from "../pages/PrivacyPolicy/";
import TermsOfUse from "../pages/TermsOfUse/";
import Connections from "../pages/Connections/";
import SettingsCustom from "../pages/SettingsCustom/";
import Users from "../pages/Users";
import Roles from "../pages/Roles";
import UserGroups from "../pages/UserGroups";
import SecurityAudit from "../pages/SecurityAudit";
import MyTeam from "../pages/MyTeam";
import Contacts from "../pages/Contacts/";
import Queues from "../pages/Queues/";
import Tags from "../pages/Tags/";
import MessagesAPI from "../pages/MessagesAPI/";
import Helps from "../pages/Helps/";
import ContactLists from "../pages/ContactLists/";
import ContactListItems from "../pages/ContactListItems/";
import { ForwardMessageProvider } from "../context/ForwarMessage/ForwardMessageContext";
// import Companies from "../pages/Companies/";
import QuickMessages from "../pages/QuickMessages/";
import BroadcastTemplates from "../pages/BroadcastTemplates/";
import WabaTemplates from "../pages/WabaTemplates/";
import Kanban from "../pages/Kanban";
import { AuthProvider } from "../context/Auth/AuthContext";
import ThemeSync from "../components/ThemeSync";
import { AuditModeProvider } from "../context/AuditMode/AuditModeContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import Route from "./Route";
//import kanbanSchedules from "../pages/kanbanSchedules/";
// Schedules deprecado: /schedules ahora apunta a AppointmentsPage (Módulo Agenda)
import Campaigns from "../pages/Campaigns";
import MetaCampaigns from "../pages/MetaCampaigns";
import ScheduledMessages from "../pages/ScheduledMessages";
// ❌ DEPRECADO: Configuración de intervalos ahora está integrada en el formulario de campañas
// import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import CampaignShippingReports from "../pages/CampaignShippingReports";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import ToDoList from "../pages/ToDoList/";
import Files from "../pages/Files/";
import Prompts from "../pages/Prompts";
import QueueIntegration from "../pages/QueueIntegration";
import ReleasesPage from "../pages/ReleasesPage"; // Historial de Versiones
import DBADashboard from "../components/DBADashboard"; // Dashboard DBA
// ✅ ELIMINADO: Performance - Ya no se necesita "Rendimiento CPU", reemplazado por "Rendimiento VPS"
import Platform from "../pages/Platform";
import FlowBuilders from "../pages/FlowBuilders"; // FlowBuilder - Lista de Flujos
import FlowCampaigns from "../pages/FlowCampaigns"; // FlowCampaigns - Campañas de Flujo
import BusinessOnboarding from "../pages/BusinessOnboarding"; // FASE 6 — Wizard configuración inicial
import AppointmentsPage from "../pages/Appointments"; // FASE 7 — Módulo Agenda

const Routes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        {/* 0390 — pide el tema en cuanto hay sesión. El estado del tema vive en
            App.js, por encima del proveedor de sesión, así que su primera carga
            ocurre sin token. Ver components/ThemeSync. */}
        <ThemeSync />
        <AuditModeProvider>
	  <ForwardMessageProvider>
        <TicketsContextProvider>
          <Switch>
            <Route exact path="/login" component={Login} isPrivate={false} />
            <Route exact path="/signup" component={Signup} isPrivate={false} />
            <Route exact path="/forgot-password" component={ForgotPassword} isPrivate={false} />
            <Route exact path="/reset-password" component={ResetPassword} isPrivate={false} />
            <Route exact path="/privacy" component={PrivacyPolicy} isPrivate={false} />
            <Route exact path="/terms" component={TermsOfUse} isPrivate={false} />
            {/* <Route exact path="/create-company" component={Companies} /> */}
            <WhatsAppsProvider>
              <LoggedInLayout>
                {/* Toda cuenta arranca en Tickets (decisión del propietario, 2026-10-27). Informes vive en /reports.
                    WHY RouterRoute + render y no <Redirect from>: este bloque NO es hijo directo de un <Switch>,
                    y fuera de un Switch un <Redirect> ignora `from` y redirige SIEMPRE. Así se llevó toda carga
                    de página a /platform durante la D6 (doc 0447 §10.15). */}
                <RouterRoute exact path="/" render={() => <Redirect to="/tickets" />} />
                <Route exact path="/reports" component={Reports} requiredPermission="reports:ver" isPrivate />
                {/* FASE 3.1 / FASE 6: Onboarding solo si el usuario entra a Agenda y aún no hay business_config (ver layout). */}
                <Route exact path="/onboarding" component={BusinessOnboarding} isPrivate />
                <Route exact path="/appointments" component={AppointmentsPage} requiredPermission="agenda:ver" isPrivate />
                <Route exact path="/agenda" component={AppointmentsPage} requiredPermission="agenda:ver" isPrivate />
                <Route
                  exact
                  path="/tickets/:ticketId?"
                  requiredPermission="tickets:ver"
                  component={TicketResponsiveContainer}
                  isPrivate
                />
                <Route
                  exact
                  path="/connections"
                  requiredPermission="connections:ver"
                  component={Connections}
                  isPrivate
                />
                <Route
                  exact
                  path="/quick-messages"
                  requiredPermission="quickmessages:ver"
                  component={QuickMessages}
                  isPrivate
                />
                <Route
                  exact
                  path="/broadcast-templates"
                  requiredPermission="campaigns:ver"
                  component={BroadcastTemplates}
                  isPrivate
                />
                <Route
                  exact
                  path="/plantillas-meta"
                  requiredPermission="campaigns:ver"
                  component={WabaTemplates}
                  isPrivate
                />
                <Route
                  exact
                  path="/todolist"
                  component={ToDoList}
                  isPrivate
                  />
                <Route exact path="/schedules" component={AppointmentsPage} requiredPermission="agenda:ver" isPrivate />
                <Route exact path="/tags" component={Tags} requiredPermission="tags:ver" isPrivate />
                <Route exact path="/contacts" component={Contacts} requiredPermission="contacts:ver" isPrivate />
                <Route exact path="/helps" component={Helps} isPrivate />
                <Route exact path="/groups-wa" component={GroupsWA} requiredPermission="groups:ver" isPrivate />
                <Route exact path="/group-campaigns" component={GroupCampaigns} requiredPermission="campaigns:ver" isPrivate />
                <Route exact path="/users" component={Users} requiredPermission="users:ver" isPrivate />
                <Route exact path="/roles" component={Roles} requiredPermission="roles:ver" isPrivate />
                <Route exact path="/user-groups" component={UserGroups} requiredPermission="user-groups:ver" isPrivate />
                <Route exact path="/security-audit" component={SecurityAudit} requiredPermission="settings:administrar" isPrivate />
                <Route exact path="/my-team" component={MyTeam} isPrivate />
                <Route exact path="/files" component={Files} requiredPermission="files:ver" isPrivate />
                <Route exact path="/prompts" component={Prompts} requiredPermission="prompts:ver" isPrivate />
                <Route exact path="/queue-integration" component={QueueIntegration} requiredPermission="settings:administrar" isPrivate />
                <Route exact path="/releases" component={ReleasesPage} isPrivate />
                <Route exact path="/dashboard/monitoring" component={DBADashboard} requiredPermission="settings:administrar" isPrivate />
                {/* ✅ ELIMINADO: Ruta "/dashboard/performance" - Ya no se necesita "Rendimiento CPU" */}
                {/* Estado de la plataforma (doc 0447, D6c): el servidor. «Conexiones» y «WhatsApp» se retiraron. */}
                <Route exact path="/platform" component={Platform} superOnly isPrivate />
                <RouterRoute exact path={["/dashboard/connections", "/dashboard/whatsapp", "/dashboard/vps-performance"]} render={() => <Redirect to="/platform" />} />
					{/*<Route exact path="/kanban-schedules" component={kanbanSchedules} isPrivate />*/}
                <Route
                  exact
                  path="/messages-api"
                  requiredPermission="api:ver"
                  component={MessagesAPI}
                  isPrivate
                />
                <Route
                  exact
                  path="/settings"
                  requiredPermission="settings:ver"
                  component={SettingsCustom}
                  isPrivate
                />
				        <Route 
                  exact
                  path="/kanban"
                  requiredPermission="kanban:ver"
                  component={Kanban}
                  isPrivate
                />
                <Route exact path="/queues" component={Queues} requiredPermission="queues:ver" isPrivate />
                <Route
                  exact
                  path="/announcements"
                  requiredPermission="announcements:ver"
                  component={Annoucements}
                  isPrivate
                />
                <Route exact path="/chats/:id?" component={Chat} requiredPermission="chats:ver" isPrivate />
                <Route exact path="/flowbuilders" component={FlowBuilders} requiredPermission="flowbuilder:ver" isPrivate />
                <Route exact path="/flowbuilders/new" component={FlowBuilders} requiredPermission="flowbuilder:ver" isPrivate />
                <Route exact path="/flowbuilders/:id/edit" component={FlowBuilders} requiredPermission="flowbuilder:ver" isPrivate />
                <Route exact path="/flowcampaigns" component={FlowCampaigns} requiredPermission="flowbuilder:ver" isPrivate />
                {showCampaigns && (
                  <>
                    <Route
                      exact
                      path="/contact-lists"
                      requiredPermission="campaigns:ver"
                      component={ContactLists}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/contact-lists/:contactListId/contacts"
                      requiredPermission="campaigns:ver"
                      component={ContactListItems}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/campaigns"
                      requiredPermission="campaigns:ver"
                      component={Campaigns}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/meta-campaigns"
                      requiredPermission="campaigns:ver"
                      component={MetaCampaigns}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/scheduled-messages"
                      requiredPermission="schedules:ver"
                      component={ScheduledMessages}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/campaign/:campaignId/report"
                      requiredPermission="campaigns:ver"
                      component={CampaignReport}
                      isPrivate
                    />
                    <Route
                      exact
                      path="/campaign-shipping-reports"
                      requiredPermission="campaigns:ver"
                      component={CampaignShippingReports}
                      isPrivate
                    />
                    {/* ❌ DEPRECADO: Configuración de intervalos ahora está integrada en el formulario de campañas */}
                    {/* <Route
                      exact
                      path="/campaigns-config"
                      requiredPermission="campaigns:editar"
                      component={CampaignsConfig}
                      isPrivate
                    /> */}
                  </>
                )}
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        </TicketsContextProvider>
		</ForwardMessageProvider>
        </AuditModeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
